import { render, staticRenderFns } from "./crudLists.vue?vue&type=template&id=a232950a&"
import script from "./crudLists.vue?vue&type=script&lang=js&"
export * from "./crudLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports